import { NamedProperty } from "sprint-common-web";

import {
    EpisodeResponseItem,
    SeasonResponseItem,
    TvSeriesEntryResponseItem,
    TvSeriesResponseItem
} from "../../../common/api/catalogue-api/tv-api/SearchTvSeriesEntriesResponse";

export type TvSeriesSearchItem = TvSeriesItem | SeasonItem | EpisodeItem;

export interface TvSeriesItem {
    type: "tv-series";
    tvSeriesId: string;
    tvSeriesName: string;
}

export interface SeasonItem {
    type: "season";
    tvSeriesId: string;
    tvSeriesName: string;
    seasonId: string;
    seasonName: string;
}

export interface EpisodeItem {
    type: "episode";
    tvSeriesId: string;
    tvSeriesName: string;
    seasonId: string;
    seasonName: string;
    episodeId: string;
    episodeName: string;
    episodeNumber: number;
    assetsCount: number;
    types: number[];
    distributors?: string;
}

interface EpisodeAssetsData {
    assetsCount: number;
    types: number[];
}

export const mapToTvSeriesSearchItem = (
    item: TvSeriesEntryResponseItem,
    { assetsCount, types }: EpisodeAssetsData
): TvSeriesSearchItem => {
    switch (item.type) {
        case "tv-series": {
            return mapToTvSeriesItem(item);
        }

        case "season": {
            return mapToSeasonItem(item);
        }

        case "episode": {
            return mapToEpisodeItem(item, { assetsCount, types });
        }

        default: {
            throw new Error("Incorrect entry type.");
        }
    }
};

const mapToTvSeriesItem = (item: TvSeriesResponseItem): TvSeriesItem => ({
    type: "tv-series",
    tvSeriesId: item.tvSeries.id,
    tvSeriesName: item.tvSeries.name
});

const mapToSeasonItem = (item: SeasonResponseItem): SeasonItem => ({
    type: "season",
    tvSeriesId: item.tvSeries.id,
    tvSeriesName: item.tvSeries.name,
    seasonId: item.season.id,
    seasonName: item.season.name
});

export const mapToEpisodeItem = (
    item: EpisodeResponseItem,
    { assetsCount, types }: EpisodeAssetsData
): EpisodeItem => ({
    type: "episode",
    tvSeriesId: item.tvSeries.id,
    tvSeriesName: item.tvSeries.name,
    seasonId: item.season.id,
    seasonName: item.season.name,
    episodeId: item.episode?.id,
    episodeName: item.episode?.name,
    episodeNumber: item.episode?.number,
    distributors: item.distributors?.map((distributor: NamedProperty) => distributor.name).join(", "),
    assetsCount,
    types
});
